/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export const COORDINATION_TYPE_ASYNC = "async";
export const COORDINATION_TYPE_WAIT_FOR_FINISH = "wait-for-finish";
export const COORDINATION_TYPE_WAIT_FOR_RESULT = "wait-for-result";

export const CoordinationType = {
    [COORDINATION_TYPE_ASYNC]: {
        name: "Async invocation",
    },
    [COORDINATION_TYPE_WAIT_FOR_FINISH]: {
        name: "Wait for coordination finish",
    },
    [COORDINATION_TYPE_WAIT_FOR_RESULT]: {
        name: "Invoke and wait for result",
    },
};

export default declareEntity({
    entity: "coordinationDefs",
    graphQL: "CoordinationDef",
    name: "Coordination Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    fields: (types) => { return {
        id: {
            name: "Coordination ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        name: {
            name: "Name",
            trim: true,
            type: "string",
            isPublic: true,
            translatable: true,
            filterable: true,
            defaultValue: "",
        },
        type: {
            name: "Type",
            trim: true,
            type: "string",
            isPublic: true,
            defaultValue: "",
            validations: {
                matchRegexp: /^[a-zA-Z0-9\.\-_]+$/,
            }
        },
        eventType: {
            name: "Event Type",
            type: "enum",
            defaultValue: COORDINATION_TYPE_ASYNC,
            values: CoordinationType,
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            isPublic: true,
            defaultValue: ""
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
